import { supabase } from "@/integrations/supabase/client";

export type LeadInsertPayload = {
  listing_id: string;
  dealer_id?: string | null;
  contact_type: 'phone' | 'email' | 'whatsapp' | 'sms' | 'message';
  lead_type?: 'message' | 'offer' | 'reserve' | 'phone_click' | 'whatsapp_click' | 'email_click';
  country?: string | null;
  session_id?: string | null;
  user_id?: string | null;
  ip_address?: string | null;
  user_agent?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  message?: string | null;
  status?: string;
  dealer_notified_at?: string | null;
};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

/**
 * Insert a contact lead with retry (exponential backoff) and persistent
 * error logging to lead_capture_errors. Returns true on success, false on
 * permanent failure.
 */
export async function captureLead(payload: LeadInsertPayload): Promise<boolean> {
  const maxAttempts = 3;
  let lastError: any = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const { error } = await supabase.from('contact_leads').insert(payload as any);
      if (!error) return true;
      lastError = error;
    } catch (err) {
      lastError = err;
    }
    if (attempt < maxAttempts) {
      await sleep(300 * attempt); // 300ms, 600ms
    }
  }

  // Persistent log so we detect future RLS / constraint regressions instantly.
  try {
    await supabase.from('lead_capture_errors').insert({
      listing_id: payload.listing_id,
      attempted_payload: payload as any,
      error_message: lastError?.message || String(lastError),
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    });
  } catch {
    // swallow — logging best-effort
  }

  console.error('[lead-capture] permanent failure', lastError);
  return false;
}
